import { useContext } from "react";

import { CharlotteChatContext } from "@/components/charlotte-chat/CharlotteChatContext";

export const useCharlotteChat = () => {
  const context = useContext(CharlotteChatContext);

  if (!context) {
    throw new Error(
      "useCharlotteChat must be used inside CharlotteChatProvider",
    );
  }

  return context;
};
